import { useMemo } from "react";
import { CandidatesWithApplicationsQuery } from "../graphql/generated/graphql";

export function useFilteredCandidates(
  candidatesData: CandidatesWithApplicationsQuery | undefined,
  safeJobId: number
) {
  return useMemo(() => {
    if (!candidatesData?.candidates?.nodes) return [];

    return candidatesData.candidates.nodes.filter((candidate) =>
      candidate?.jobsApplications?.nodes.some(
        (application) => application.job?.id === safeJobId
      )
    );
  }, [candidatesData?.candidates?.nodes, safeJobId]);
}
